import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainNavigationComponent } from '@ace/ace';
import { AuthserviceService } from './core/guard/authservice.service';

const routes: Routes = [
  {
    path: "login",
    loadChildren: () =>
      import("@ace/ace").then(
        (m) => m.LoginModule,
      )
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import("@ace/ace").then(
        (m) => m.ForgotPasswordModule,
      )
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'main',
    component: MainNavigationComponent,
    children: [
      {
        path: 'avatar-interactions',
        loadChildren: () =>
          import("./layouts/avatar-interactions/avatar-interactions.module").then(
            (m) => m.AvatarInteractionsModule,
          )
      },
      {
        path: 'landing-page',
        loadChildren: () =>
          import("./layouts/landing-page/landing-page.module").then(
            (m) => m.LandingPageModule,
          )
      },
      {
        path: 'landing-list/:moduleId',
        loadComponent: () =>
          import('@ace/ace').then((m) => m.DynamicLandingListComponent),
      },
      {
        path: 'noise-management',
        loadChildren: () =>
          import('./layouts/noise-management/noise-management.module').then(
            (m) => m.NoiseManagementModule
          ),
      },
      {
        path: 'master-management-v2',
        loadChildren: () =>
          import("@ace/ace").then(
            (m) => m.MasterManagementV2Module,
          )
      },
      {
        path: 'master-management-v2/menus',
        loadChildren: () =>
          import("@ace/ace").then(
            (m) => m.MasterManagementV2Module,
          )
      },
      {
        path: "user-management",
        loadChildren: () =>
          import("@ace/ace").then(
            (m) => m.UserManagementModule,
          )
      },
      {
        path: 'avatar-configuration',
        loadChildren: () =>
          import("./layouts/avatar-configuration/avatar-configuration.module").then(
            (m) => m.AvatarConfigurationModule,
          )
      },
      {
        path: 'camera-settings',
        loadComponent: () =>
          import('./layouts/avatar-configuration/camera-settings/camera-settings.component').then(
            (m) => m.CameraSettingsComponent,
          )
      },
      {
        path: 'user-logging',
        loadChildren: () =>
          import("@ace/ace").then(
            (m) => m.UserLoggingModule,
          )
      },
      {
        path: ':moduleId/form/:action',
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import('@ace/ace').then((m) => m.FormHandlingComponent),
          },
          {
            path: '',
            loadComponent: () =>
              import('@ace/ace').then((m) => m.FormHandlingComponent),
          },
        ],
      },

      {
        path: 'avatar',
        loadChildren: () =>
          import("./layouts/avatar/avatar.module").then(
            (m) => m.AvatarModule,
          )
      },
      {
        path: 'playlists',
        loadChildren: () =>
          import("./layouts/playlists/playlists.module").then(
            (m) => m.PlaylistsModule,
          )
      },
      {
        path: 'playlists-videos-configuration',
        loadChildren: () =>
          import("./layouts/playlist-video-configuration/playlist-video-configuration.module").then(
            (m) => m.PlaylistVideoConfigurationModule,
          )
      },
      {
        path: 'conversation-mode',
        loadChildren: () =>
          import("./layouts/conversation-mode/conversation-mode.module").then(
            (m) => m.ConversationModeModule,
          )
      },
      {
        path: 'channel-management',
        loadChildren: () =>
          import('./layouts/channel-management/channel-management..module').then(
            (m) => m.ChannelManagementModule
          ),
      },
      {
        path: 'out-of-scope',
        loadChildren: () =>
          import('./layouts/out-of-scope/out-of-scope.module').then(
            (m) => m.OutOfScopeModule
          ),
      },
      {
        path: 'session-drop-off',
        loadChildren: () =>
          import('./layouts/session-drop-off/session-drop-off.module').then(
            (m) => m.SessionDropOffModule
          ),
      },
      {
        path: 'reported-messages',
        loadChildren: () =>
          import('./layouts/reported-messages/reported-messages.module').then(
            (m) => m.ReportedMessagesModule
          ),
      },
      {
        path: 'faq-management',
        loadChildren: () =>
          import('./layouts/faq-management/faq-management.module').then(
            (m) => m.FaqManagementModule
          ),
      },
      {
        path: 'context-management',
        loadChildren: () =>
          import('./layouts/context-management/context-management.module').then(
            (m) => m.ContextManagementModule
          ),
      },
      {
        path: 'knowledge-intake',
        loadChildren: () =>
          import('./layouts/knowledge-intake/knowledge-intake.module').then(
            (m) => m.KnowledgeIntakeModule
          ),
      },
      {
        path: 'trending-topics',
        loadChildren: () =>
          import('./layouts/trending-topics/trending-topics.module').then(
            (m) => m.TrendingTopicsModule
          ),
      },
      {
        path: 'audit-trail',
        loadChildren: () =>
          import('@ace/ace').then(
            (m) => m.AuditTrailModule
          ),
      },
      {
        path: 'user-experience',
        loadChildren: () =>
          import('./layouts/user-experience/user-experience.module').then(
            (m) => m.UserExperienceModule
          ),
      },

    ], canActivate: [AuthserviceService]
  },
  // { path: '**', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
